import React, { useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import './header.scss';

import logo from '../../assets/logo1.png';
import MovieIcon from '@mui/icons-material/Movie';
import TvIcon from '@mui/icons-material/Tv';
import SearchIcon from '@mui/icons-material/Search';
const headerNav = [
    {
        display: 'Movies',
        path: '/',
        icon:<MovieIcon style={{color:'#25dde4',marginTop:'6px',marginRight:'5px'}}/>
    },
    {
        display: 'TV Series',
        path: '/seriesHome',
        icon:<TvIcon style={{color:'#25dde4',marginTop:'6px',marginRight:'5px'}}/>
    },
    {
        display: 'Search',
        path: '/all',
        icon:<SearchIcon style={{color:'#25dde4',marginTop:'6px',marginRight:'5px'}}/>
    }
];

const Header = () => {

    const { pathname } = useLocation();
    const headerRef = useRef(null);

    const active = headerNav.findIndex(e => e.path === pathname);

    useEffect(() => {
        const shrinkHeader = () => {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                headerRef.current.classList.add('shrink');
            } else {
                headerRef.current.classList.remove('shrink');
            }
        }
        window.addEventListener('scroll', shrinkHeader);
        return () => {
            window.removeEventListener('scroll', shrinkHeader);
        };
    }, []);

    return (
        <div ref={headerRef} className="header">
            <div className="header__wrap container">
                <div className="logo">
                    <Link to="/"> <img src={logo} alt="Header Logo" /></Link>
                </div>
                <ul className="header__nav">
                    {
                        headerNav.map((e, i) => (
                            <li key={i} className={`${i === active ? 'active' : ''}`}>
                                <Link to={e.path}>
                                   <div style={{display:'flex'}}>
                                    {e.icon}
                                    {e.display}</div> 
                                </Link>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    );
}

export default Header;
